import React from 'react'
import { Link, LinkProps, useHistory } from 'react-router-dom'
import { getCurrentReturnUrl, pushNavigationStack } from './navigationStack'

interface StackLinkProps extends LinkProps {
  backLabel: string
  backUrl?: string
}

export function StackLink({ backLabel, backUrl, onClick, to, ...rest }: StackLinkProps) {
  const history = useHistory()

  return (
    <Link
      {...rest}
      to={to}
      onClick={event => {
        pushNavigationStack({
          url: backUrl ?? getCurrentReturnUrl(history),
          label: backLabel,
        })
        onClick?.(event)
      }}
    />
  )
}
